<template>
  <ValidationProvider
    name="Username"
    rules="required"
    v-slot="{ errors }"
    immediate
  >
    <v-autocomplete
      label="Radius Account"
      :items="accounts"
      v-model="selected"
      item-text="name"
      item-value="radiusId"
      :error-messages="errors"
      @change="emit"
    ></v-autocomplete>
  </ValidationProvider>
</template>

<script>
export default {
  name: "RadiusAccounts",
  data: () => ({
    accounts: [],
    selected: null,
  }),
  beforeMount() {
    let vm = this;
    vm.getRadiusAccounts().then((data) => {
      vm.accounts = data;
    });
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    async emit(val) {
      this.$store.dispatch("service/setRadiusAccount", val);
      let detail = this.accounts.find((x) => x.radiusId === val);
      this.getGroupListForAccount(val);
      await this.getActiveWholesalers({
        keyword: detail.radiusId.toString(),
        pageSize: 0,
        showCancelled: true,
      });
      let activeWholesaler = this.activeWholesalers.filter(
        (x) => x.radiusAccountId == detail.radiusId
      )[0];
      let service = {
        ...this.details,
        accountNumber: activeWholesaler.ubCustomerNumber,
      };
      this.$store.dispatch("service/setDetails", service);
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped></style>
